interface WaterfallViewOptionProps {
  title: string;
  description: string;
}

export function WaterfallViewOption({
  title,
  description,
}: WaterfallViewOptionProps) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="font-semibold text-foreground">{title}</span>
      <span className="text-[10px] text-muted-foreground font-normal">
        {description}
      </span>
    </div>
  );
}
